import { render, staticRenderFns } from "./businessAdvertise.vue?vue&type=template&id=b9458f10&scoped=true&"
import script from "./businessAdvertise.vue?vue&type=script&lang=ts&"
export * from "./businessAdvertise.vue?vue&type=script&lang=ts&"
import style0 from "./businessAdvertise.vue?vue&type=style&index=0&id=b9458f10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9458f10",
  null
  
)

export default component.exports